export function reverseAriaExpanded(el) {
  el.setAttribute(
    'aria-expanded',
    el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
  );
}

// trap focus
export function trapFocus(element) {
  const KEYCODE_TAB = 9;
  const focusableEls = element.querySelectorAll(`
    a[href]:not([disabled]),
    button:not([disabled]),
    textarea:not([disabled]),
    input[type="text"]:not([disabled]),
    input[type="radio"]:not([disabled]),
    input[type="checkbox"]:not([disabled]),
    select:not([disabled])
  `);
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  // set focus to first element
  firstFocusableEl.focus();

  element.addEventListener('keydown', function (e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

// Smooth scroll for in-page anchor links
document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href*="#"]');
  if (!link) {
    return;
  }

  const href = link.getAttribute('href');

  // Ignore empty hashes or JS links
  if (!href || href === '#' || href.startsWith('javascript:')) {
    return;
  }

  let url;
  try {
    url = new URL(href, window.location.href);
  } catch (e) {
    return;
  }

  // Only handle same-page anchors
  if (
    url.origin !== window.location.origin ||
    url.pathname !== window.location.pathname ||
    !url.hash
  ) {
    return;
  }

  const targetId = url.hash.substring(1);
  const targetElement =
    document.getElementById(targetId) ||
    document.querySelector(`[name="${targetId}"]`);

  if (!targetElement) {
    return;
  }

  event.preventDefault();

  // Smooth scroll to the target with 64px offset (e.g. for fixed header)
  const offset = 96;
  const targetPosition =
    targetElement.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth',
  });
});
